export default __webpack_public_path__ + "static/media/add_rounded.f01c3579.png";